import dayjs from 'dayjs';
import { logitify } from '@/store/socket';


export default {
  async init() {
    if (!window.APP_TRON) {
      return;
    }
    const { ipcRenderer } = window.APP_TRON;
    const writeLog = (level, ts, source, str) => {
      ipcRenderer.send('logToFile', `${level} ${ts} ${source} ${str}\n`);
    };
    const originalConsoleLog = console.log.bind(console);
    console.log = (...args) => {
      const ts = dayjs().format('DD.MM|HH:mm:ss.SSS');
      writeLog('     ', ts, document.location.hash, args.reduce((acc, el) => `${acc} ${typeof el === 'string' ? el : logitify(el)}`, ''));
      const logArgs = [...args];
      if (logArgs.length) {
        logArgs[0] = `${ts} ${logArgs[0]}`; // concatenate because if we will add ts to arr it will break color formatting
      }
      originalConsoleLog(...logArgs);
    };

    window.onerror = (err) => {
      const ts = dayjs().format('DD.MM HH:mm:ss.SSS');
      writeLog('ERROR', ts, document.location.hash, err);
    };

    // process.on('uncaughtException', (err) => {
    //   const ts = dayjs().format('DD.MM HH:mm:ss.SSS');
    //   writeLog('EXCEP', ts, document.location.hash, err);
    // });
  },
};
